import controller from './thank-you.controller';
import template from './thank-you.pug';

const ThankYouComponent = {
  template,
  controller,
};

export default ThankYouComponent;



// WEBPACK FOOTER //
// ./client/app/thank-you/thank-you.component.js